import React, { useState } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
import '../all/Main.css';
import { Link } from 'react-router-dom';

const View = () => {
  const [isHovered, setIsHovered] = useState(false);

  const x = useMotionValue(0);
  const y = useMotionValue(0);

  const springConfig = { stiffness: 150, damping: 15, mass: 0.1 };
  const animateX = useSpring(x, springConfig);
  const animateY = useSpring(y, springConfig);

  const handleMouse = (event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    x.set((event.clientX - centerX) * 0.25);
    y.set((event.clientY - centerY) * 0.25);
  };

  const resetMouse = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <div className="d-flex justify-content-md-start justify-content-end align-items-center">
      <motion.div
        style={{ x: animateX, y: animateY }}
        onMouseMove={handleMouse}
        onMouseLeave={() => {
          resetMouse();
          setIsHovered(false);
        }}
        onMouseEnter={() => setIsHovered(true)}
      >
        <div style={{ position: 'relative', padding: '2px', borderRadius: '50px' }}>
          
          {/* Rotating Border */}
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 4, repeat: Infinity, ease: 'linear' }}
            style={{
              position: 'absolute',
              inset: '-2px',
              borderRadius: '50px',
              background: isHovered
                ? 'conic-gradient(from 0deg, transparent, #b22335, transparent)'
                : 'conic-gradient(from 0deg, transparent, rgba(178,35,53,0.25), transparent)',
              filter: 'blur(1px)',
              zIndex: 0,
            }}
          />

          {/* Refined Glow */}
          <motion.div
            animate={{
              opacity: isHovered ? 0.45 : 0.15,
              scale: isHovered ? 1.04 : 1,
            }}
            transition={{ duration: 0.5 }}
            style={{
              position: 'absolute',
              inset: '-8px',
              borderRadius: '50px',
              background: '#b22335',
              filter: 'blur(18px)',
              zIndex: 0,
            }}
          />

          {/* Button */}
          <motion.button
            className="btn position-relative overflow-hidden"
            style={{
              background: '#ffffff',
              border: 'none',
              borderRadius: '50px',
              padding: '10px 24px',
              cursor: 'pointer',
              zIndex: 1,
              boxShadow: `0 0 20px rgba(178, 35, 53, ${
                isHovered ? 0.18 : 0.08
              })`,
              transition: 'all 0.4s ease',
            }}
            whileTap={{ scale: 0.96 }}
          >
            {/* Shine Sweep */}
            <motion.div
              style={{
                position: 'absolute',
                top: 0,
                left: '-100%',
                width: '100%',
                height: '100%',
                background:
                  'linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent)',
                zIndex: 1,
              }}
              animate={{ left: isHovered ? '100%' : '-100%' }}
              transition={{ duration: 0.8 }}
            />

            {/* Content */}
            <div
              className="d-flex align-items-center gap-2 position-relative"
              style={{ zIndex: 2 }}
            >
              <motion.div
                animate={{
                  scale: isHovered ? [1, 1.25, 1] : 1,
                }}
                transition={{
                  duration: 1,
                  repeat: isHovered ? Infinity : 0,
                }}
                style={{
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  background: '#b22335',
                  flexShrink: 0,
                }}
              />

              <motion.div
                animate={{
                  letterSpacing: isHovered ? '0.8px' : '0.3px',
                }}
                transition={{ duration: 0.35 }}
              >
                <Link
                  to="/commercial-roofing"
                  className="view-btn-text"
                  style={{
                    textDecoration: 'none',
                    fontFamily: "'hauora-medium', sans-serif",
                    fontWeight: 700,
                    fontSize: '15px',
                    color: '#2b4d8d',
                    whiteSpace: 'nowrap',
                  }}
                >
                  See More..
                </Link>
              </motion.div>
            </div>
          </motion.button>
        </div>
      </motion.div>

      <style>
        {`
          @media (max-width: 768px) {
            .view-btn-text {
              font-size: 13px !important;
            }

            .btn {
              padding: 8px 18px !important;
            }
          }

          @media (max-width: 576px) {
            .view-btn-text {
              font-size: 12px !important;
            }

            .btn {
              padding: 7px 16px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default View;
